<!--
 * @FileDescription: 移动端：订单状态组件
 * @Author: 苏子龙
 * @Date: 2021/4/19
 -->
<!--
  <status color="green">绿色</status>
  <status color="red">红色</status>
  <status color="orange">橙色</status>
  <status color="gray">灰色</status>
  <status color="violet">紫色</status>
  <status color="blue">蓝色</status>
 -->
<template>
  <div class="mobile-status" :style="{ color: colorMap[color].color, background: colorMap[color].background }">
    <div class="round" :style="{ background: colorMap[color].color }" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Status',
  props: {
    color: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      colorMap: {
        default: {
          color: '#0097A7',
          background: '#f0f9fa'
        },
        green: {
          color: '#47C455',
          background: '#F2FFF3'
        },
        red: {
          color: '#F96954',
          background: '#FFF5F4'
        },
        orange: {
          color: '#FC9D37',
          background: 'rgba(250,193,132,0.12)'
        },
        gray: {
          color: '#8193AE',
          background: '#F1F3F5'
        },
        // 紫色
        violet: {
          color: '#A74EEF',
          background: '#FBF5FF'
        },
        blue: {
          color: '#4AA0F6',
          background: '#F3FCFF'
        }
      }
    }
  },
  created() {
    if (!(this.color in this.colorMap)) {
      throw new Error(`${this.color}is not the right color`)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .mobile-status{
    height: .6rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-grow: nowrap;
    padding: 0 .24rem;
    line-height: .72rem;
    border-radius: .3rem;
    user-select: none;
    white-space: nowrap;

    .round{
      width: .14rem;
      height: .14rem;
      margin-right: .1rem;
      border-radius: 100%;
    }
  }
}
@media screen and (min-width: 1000px) {
  .mobile-status{
    height: 36px;
    line-height: 36px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-grow: nowrap;
    padding: 0 14px;
    border-radius: 20px;
    user-select: none;
    white-space: nowrap;

    .round{
      width: 6px;
      height: 6px;
      margin-right: 7px;
      border-radius: 100%;
    }
  }
}
</style>
